module.exports = __webpack_public_path__ + "static/5-6655fa00d395afc29b5ccf2a30ab02ef.jpg";